import { Component, OnInit } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-logo-header',
  templateUrl: './logo-header.component.html',
})
export class LogoHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
